import { useEffect } from "react";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/hooks";
import { logout } from "../store/features/auth/auth";

export const useCookieWatch = () => {
  const dispatch = useAppDispatch();
  const { userToken } = useSelector((state) => state.entities.auth);

  useEffect(() => {
    const checkCookie = () => {
      const isCookieExpired = !Cookies.get("userToken");

      if (!!userToken && isCookieExpired) {
        dispatch(logout());
      }
    };

    checkCookie();

    const handleFocus = () => {
      checkCookie();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkCookie();
      }
    };
    const intervalId = setInterval(checkCookie, 60000);

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch, userToken]);
};
